// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__oyQXL","rotation":"Spinner_rotation__GtG+a"};